import React from 'react';
import { useTranslation } from 'react-i18next';
export default function AboutUs() {

    const { t } = useTranslation();
    return (
        <div id="about" className="position-relative">

            <div id="about-bg" className="item tw-py-10 bg-item1">
                <div className="about-font-style">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-sm-12 mb-3">
                                <div className="d-flex align-items-center justify-content-center h-100">
                                    <div className="tw-mx-10">
                                        <h1 className="text-white mb-3 tw-font-bold tw-text-4xl">
                                            <b>
                                                {t("about-header")}
                                            </b></h1>
                                        <p className="text-white tw-text-sm tw-leading-relaxed tw-text-justify">
                                        {t("about-content")}
                                        </p>


                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-sm-12">
                                <div className="tw-flex tw-flex-col tw-gap-3 tw-p-4">
                                    <div className="tw-relative tw-h-32 tw-rounded-lg tw-overflow-hidden tw-shadow-md hover:tw-shadow-lg tw-transition-shadow">
                                        <img src="/img/Business.png" alt="Business" className="tw-w-full tw-h-full tw-object-cover" />
                                        <p className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-font-semibold tw-text-white tw-text-lg tw-bg-black tw-bg-opacity-30">Business</p>
                                    </div>
                                    <div className="tw-relative tw-h-32 tw-rounded-lg tw-overflow-hidden tw-shadow-md hover:tw-shadow-lg tw-transition-shadow">
                                        <img src="/img/Corporate.png" alt="Corporate" className="tw-w-full tw-h-full tw-object-cover" />
                                        <p className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-font-semibold tw-text-white tw-text-lg tw-bg-black tw-bg-opacity-30">Corporate</p>
                                    </div>
                                    <div className="tw-relative tw-h-32 tw-rounded-lg tw-overflow-hidden tw-shadow-md hover:tw-shadow-lg tw-transition-shadow">
                                        <img src="/img/Private_Client.png" alt="Private Client" className="tw-w-full tw-h-full tw-object-cover" />
                                        <p className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-font-semibold tw-text-white tw-text-lg tw-bg-black tw-bg-opacity-30">Private Client</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}
